import { Generic } from './Link';
export function isLink(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isLink;    //# sourceMappingURL=isLink.js.map
